<template>
  <div>
	  <Header  :sel='4' @changePhone="changePhone"/>
	  <!--neirong-->
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner">
	      <div class="banner_txt">
	        <p><strong>PRODUCTS</strong></p>
	        <p>产品中心</p>
	      </div>
	    </div>
	    <!--banner--> 
	    
	    <!--neirong-->
	    <div class="neirong"> 
	      <!--left-->
	      
	      <div class="bread"> <a href="javascript:void(0)" @click="goNext('/')">首页</a> - <a href="javascript:void(0)" @click="goNext('/productList')">产品中心</a> - <a href="javascript:void(0)">{{detail.productName}}</a></div>
	      <div class="neirong_c">
	        <p align="center"><img :src="detail.image" /></p>
	         <p v-html="detail.content"></p>
	      </div>
	    </div>
		 <Footer/>
		</div>
	  
	  
	  
	  <!--neirong--> 
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{infoDetail} from '@/api/reqFetch.js'
	import{LH} from '@/utils/util.js'
	
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			id:'',
			detail:{},
			showPhone:false
		}
  	},

  	mounted() {
		this.id=this.$route.query.id
      this.getNewDetail();
  	},

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		getNewDetail(){
			infoDetail({id:this.id}).then(res => {  
			    this.detail = res.data;
			});
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		}
     
  	}
  }
</script>

<style scoped>/*内容*/
.banner{
	background-image: url('../../assets/images/banner_04.png');
}
</style>
